import { Button, ButtonGroup, DialogFooter, DialogHeader, Message } from '@wg/wows-react-uikit'
import classNames from 'classnames'
import React, { PureComponent } from 'react'
import Highlighter from 'react-highlight-words'
import { t } from '../../helpers/localization'
import '../../styles/leaflet.scss'
import { Center } from '../UIKit/UIKit'
import styles from './ViewSupply.scss'
import settings from "settings";

type IFooter_Props = {
    isOwnBase: boolean,
    selectedBuildingId: string | null,
    confirmBuildingId: string | null,
    dropSelection: () => void,
    navigateToTreasury: () => void,
    bonus: string | null
}
type IFooter_State = {}

class Footer extends PureComponent<IFooter_Props, IFooter_State> {

    getTitle = () => {

        if (this.props.level === 0) {
            return null
        }
        if (this.props.confirmBuildingId || this.props.tempHoverBuildingId) {
            if (!this.props.bonus || this.props.bonus === '') {
                return null
            }
            return (
                <DialogHeader noUnderline>{t('Улучшение дает следующий бонус')}</DialogHeader>
            )

        } else {
            if (!this.props.bonus || this.props.bonus === '') {
                return null
            } else {
                return (
                    <DialogHeader noUnderline>{t('Активные бонусы строения')}</DialogHeader>
                )
            }
        }
    }

    render() {
        const isTreasurySelected = this.props.selectedBuildingId === 'treasury'
        const bundlesEnabled = settings.treasury.bundlesEnabled
        return (
            <div className={classNames(styles.buildingBottomInfo, this.props.selectedBuildingId && styles.isShow)}>

                {this.getTitle()}

                {this.props.bonus ? (
                    <Center>
                        <Message
                            style={'inline'}
                            type={'none'}>

                            <div className={styles.paddingWrapper}>
                                <Highlighter
                                    highlightClassName="HighlightPercent"
                                    searchWords={window.localSettings.highlighterPercentRegexp}
                                    textToHighlight={this.props.bonus}
                                />
                            </div>

                        </Message>
                    </Center>
                ) : null}
                {(this.props.level === 0) ? (
                    <Center>
                        <span className={styles.notBuiltFooterStatus}>{t('Здание не построено')}</span>
                    </Center>
                ) : null}

                <DialogFooter>
                    <ButtonGroup>
                        <Button onClick={this.props.dropSelection}>{t('Вернуться на базу')}</Button>
                        {(isTreasurySelected && !this.props.tempHoverBuildingId && this.props.level > 0 && this.props.isOwnBase && bundlesEnabled) ? (
                            <Button onClick={this.props.navigateToTreasury}>
                                {t('Перейти в казну')}
                            </Button>
                        ) : null}
                    </ButtonGroup>
                </DialogFooter>
            </div>
        )
    }
}

export default Footer